/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Tiles
 */

/** @internal */
export interface FeatureAttributeDrivenSymbology {
  rendererFields?: string[];
  setActiveFeatureAttributes: (attributes: { [key: string]: any }) => void;
}
